module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_7005.5886abc4.png";